import { State } from './reducers';

export const selectRootLanguage = (state: State): string => state.root.lang;

export const selectRootLoading = (state: State): boolean => state.root.loading;
